import { FormattedMessage } from 'react-intl';
import { SingleValueProps } from 'react-select';

import {
    DEBIT_CARD_TYPE,
    MANUAL_BANK_TRANSFER_TYPE,
    TRUELAYER_REPAYMENT_TYPE
} from '../EarlyRepaymentHelper';
import styles from './PaymentMethodValue.module.css';
import type { PaymentOption } from './SelectPaymentMethod';

export const PaymentMethodValue = ({
    data
}: SingleValueProps<PaymentOption, false>) => {
    const renderLabel = () => {
        switch (data.type) {
            case DEBIT_CARD_TYPE:
                return (
                    <FormattedMessage
                        id="_.select_payment_method.card_option"
                        defaultMessage="Card ●●●● {cardLastDigits}"
                        values={{ cardLastDigits: data.label }}
                    />
                );
            case 'BANK_ACCOUNT':
                return (
                    <FormattedMessage
                        id="_.select_payment_method.bank_account_option"
                        defaultMessage="Account {accountNumber}"
                        values={{ accountNumber: data.label }}
                    />
                );
            case MANUAL_BANK_TRANSFER_TYPE:
                return (
                    <FormattedMessage
                        id="_.select_payment_method.manual_payment"
                        defaultMessage="Manual Bank Transfer"
                    />
                );
            case TRUELAYER_REPAYMENT_TYPE:
                return (
                    <FormattedMessage
                        id="_.select_payment_method.truelayer_repayment"
                        defaultMessage="Instant Bank Transfer"
                    />
                );
            default:
                return <>{data.label}</>;
        }
    };

    return (
        <div data-testid="selected-value" className={styles.PaymentMethodValue}>
            <div className="Select-value">
                <span className="Select-value-label">{renderLabel()}</span>
            </div>
        </div>
    );
};
